module.exports = __webpack_public_path__ + "images/5bb9bc4f549335ec17bfb13642969ffb.svg";